import {
  HourglassIcon,
  LoaderIcon,
  ReservationCheckIcon,
} from '@/components/atoms/icons';
import {
  getReservationVisibleTone,
  ReservationVisibleTone,
  type ReservationStatus,
} from '@/core/reservation';
import React from 'react';

export interface ReservationStatusToneIconProps {
  mappedStatus: ReservationStatus;
  color: string;
  size?: number;
}

/**
 * Status icon from core reservation tone.
 * Pending → hourglass, In Progress → loader, Confirmed → check.
 */
export function ReservationStatusToneIcon({
  mappedStatus,
  color,
  size = 16,
}: Readonly<ReservationStatusToneIconProps>) {
  const tone = getReservationVisibleTone(mappedStatus);
  if (tone === ReservationVisibleTone.PENDING) {
    return <HourglassIcon size={size} color={color} />;
  }
  if (tone === ReservationVisibleTone.CONFIRMED) {
    return <ReservationCheckIcon size={size} color={color} />;
  }
  return <LoaderIcon size={size} color={color} />;
}

export default ReservationStatusToneIcon;
